<script lang="ts" setup>
import { t } from '@/locales/i18n'
import { openChat } from '@gto/widgets/fresh-chat'

interface OpenChatLinkProps {
  text?: string
}

withDefaults(defineProps<OpenChatLinkProps>(), {
  text: t('common.chat'),
})
</script>

<template>
  <a
    class="link-underline clr-primary cursor-pointer"
    @click="openChat()"
    v-html="text"
  />
</template>
